import {Button, Group, Tooltip} from "@mantine/core";
import {useQuery} from "@tanstack/react-query";
import {useLocation, useNavigate} from "react-router";
import api from "../../../utils/api.ts";

interface Props {
    moduleId: string;
}

interface NavStatus {
    isOwner?: boolean;
    billing?: {
        expired?: boolean;
    };
}

const tabs = [
    {key: 'dashboard', label: 'Dashboard'},
    {key: 'timeline', label: 'Timeline'},
    {key: 'details', label: 'Details'},
    {key: 'materials', label: 'Materials'},
    {key: 'datacards', label: 'Datacards'},
    {key: 'planner', label: 'Planner'},
    {key: 'calculator', label: 'Calculator'},
    {key: 'entities', label: 'Entities'},
    {key: 'access', label: 'Access', ownerOnly: true},
    {key: 'settings', label: 'Settings', ownerOnly: true},
];

export default function ProductionModuleNav({moduleId}: Props) {
    const navigate = useNavigate();
    const location = useLocation();

    const statusQuery = useQuery<NavStatus>({
        queryKey: ['prod-module', moduleId, 'settings'],
        queryFn: async () => (await api.get(`/modules/production/${moduleId}/settings`)).data as NavStatus,
        enabled: !!moduleId,
    });

    const isOwner = statusQuery.data?.isOwner ?? false;
    const locked = statusQuery.data?.billing?.expired ?? false;

    return (
        <Group gap="xs">
            {tabs
                .filter((tab) => !tab.ownerOnly || isOwner)
                .map((tab) => {
                    const path = `/modules/production/${moduleId}/${tab.key}`;
                    const active = location.pathname === path;
                    const disabled = locked && tab.key !== 'settings';

                    const button = (
                        <Button
                            key={tab.key}
                            size="compact-sm"
                            variant={active ? 'filled' : 'light'}
                            disabled={disabled}
                            onClick={() => {
                                if (!disabled) {
                                    navigate(path);
                                }
                            }}
                        >
                            {tab.label}
                        </Button>
                    );

                    if (disabled) {
                        return (
                            <Tooltip key={tab.key} label="Subscription expired — renew in Settings">
                                <span>{button}</span>
                            </Tooltip>
                        );
                    }

                    return button;
                })}
        </Group>
    );
}
